import { render, staticRenderFns } from "./StudentFormDialog.vue?vue&type=template&id=675c700c&scoped=true"
import script from "./StudentFormDialog.vue?vue&type=script&lang=js"
export * from "./StudentFormDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentFormDialog.vue?vue&type=style&index=0&id=675c700c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c700c",
  null
  
)

export default component.exports